<template>
  <div>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner styleGeneral">
            <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                {{ $t('common.formsSubTitle.gnrl') }}
                <i class="f7-icons formChevron">chevron_right</i>
              </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">IBAN technique</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.iban_technical">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">BIC technique</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.bic_technical">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">IBAN réel</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.iban_real">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">BIC réel</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.bic_real">
            </input>
          </div>
        </div>
      </div>
    </ul>

    <hr/>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner styleGeneral">
            <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                VIBAN
                <i class="f7-icons formChevron">chevron_right</i>
              </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group row">
            <div class="col-sm-auto">
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline1" type="radio" value="1" v-model="settings.viban_mode">
                <label class="custom-control-label" for="defaultInline1">VIBAN par projet</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline2" type="radio" value="2" v-model="settings.viban_mode">
                <label class="custom-control-label" for="defaultInline2">VIBAN par client</label>
              </div>
            </div>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Temps d'expiration (en jour)</label>
            <input class="form-control inputAccordionForm col-50" type="number" min="0" max="99"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.viban_liberation_time ">
            </input>
          </div>
        </div>
      </div>
    </ul>

    <hr/>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner styleGeneral">
            <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                PAIEMENT
                <i class="f7-icons formChevron">chevron_right</i>
              </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Seuil d'erreur minimum accepté</label>
            <input class="form-control inputAccordionForm col-50" type="number" min="0" step="0.01"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.payment_threshold_minus">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Seuil d'erreur maximum accepté</label>
            <input class="form-control inputAccordionForm col-50" type="number" min="0" step="0.01"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.payment_threshold_plus">
            </input>
          </div>
        </div>
      </div>
    </ul>

    <hr/>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner styleGeneral">
            <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                COMPTE AXEPTA ONLINE
                <i class="f7-icons formChevron">chevron_right</i>
              </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Identifiant commerçant (MID)</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.mid ">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Clé de chiffrement Blowfish</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.key_bl ">
            </input>
          </div>

          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label col-33">Clé HMAC</label>
            <input class="form-control inputAccordionForm col-50" type="text"
              style="height: calc(1.5em + 0.75rem + 2px)"
              v-model="settings.key_mac ">
            </input>
          </div>
        </div>
      </div>
    </ul>

  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id)
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    this.Dom7('.accordion-item').forEach(item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    this.Dom7('.createInvoiceBand').forEach(item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
      return 'RTP-slider'
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>



// WEBPACK FOOTER //
// MarketplaceSettings.vue?083904f8